import { CSSProperties } from 'react';

import { ReactComponent as ArrowDown } from '@/assets/home/arror_down.svg';
import { ReactComponent as BindRoleSvg } from '@/assets/icon/bindrole.svg';
import { ReactComponent as BingoSvg } from '@/assets/icon/BINGO.svg';
import { ReactComponent as CasinoSvg } from '@/assets/icon/CASINO.svg';
import { ReactComponent as CloseOutLineSvg } from '@/assets/icon/close-outline.svg';
import { ReactComponent as DeportesSvg } from '@/assets/icon/DEPORTES.svg';
import { ReactComponent as GoBackSvg } from '@/assets/icon/go_back.svg';
import { ReactComponent as HomeUserSvg } from '@/assets/icon/home_user.svg';
import { ReactComponent as HotSvg } from '@/assets/icon/HOT.svg';
import { ReactComponent as AccountType } from '@/assets/icon/icon_account_type.svg';
import { ReactComponent as ArrowLeft } from '@/assets/icon/icon_arrow_left.svg';
import { ReactComponent as ArrowRight } from '@/assets/icon/icon_arrow_right.svg';
import { ReactComponent as Back } from '@/assets/icon/icon_back.svg';
import { ReactComponent as BankSvg } from '@/assets/icon/icon_bank.svg';
import { ReactComponent as BindPhoneTipSvg } from '@/assets/icon/icon_bind_phone_tip.svg';
import { ReactComponent as Bottom } from '@/assets/icon/icon_bottom.svg';
import { ReactComponent as CopySvg } from '@/assets/icon/icon_copy.svg';
import { ReactComponent as Correct } from '@/assets/icon/icon_correct.svg';
import { ReactComponent as CorrectCircle } from '@/assets/icon/icon_correct_circle.svg';
import { ReactComponent as Crown } from '@/assets/icon/icon_crown.svg';
import { ReactComponent as DefaultUserAvatar } from '@/assets/icon/icon_default_user.svg';
import { ReactComponent as DNI } from '@/assets/icon/icon_dni.svg';
import { ReactComponent as Download } from '@/assets/icon/icon_download.svg';
import { ReactComponent as Facebook } from '@/assets/icon/icon_facebook.svg';
import { ReactComponent as Game } from '@/assets/icon/icon_game.svg';
import { ReactComponent as Hot } from '@/assets/icon/icon_hot.svg';
import { ReactComponent as Kefu } from '@/assets/icon/icon_kefu.svg';
import { ReactComponent as LightningSvg } from '@/assets/icon/icon_lightning.svg';
import { ReactComponent as Link } from '@/assets/icon/icon_link.svg';
import { ReactComponent as MailSvg } from '@/assets/icon/icon_mail.svg';
import { ReactComponent as MailDeleteSvg } from '@/assets/icon/icon_mail_delete.svg';
import { ReactComponent as MailReadSvg } from '@/assets/icon/icon_mail_read.svg';
import ManyRs from '@/assets/icon/icon_many_rs.webp';
import { ReactComponent as My } from '@/assets/icon/icon_my.svg';
import { ReactComponent as MyGoldSvg } from '@/assets/icon/icon_my_gold.svg';
import { ReactComponent as MyGoldSimpleSvg } from '@/assets/icon/icon_my_gold_simple.svg';
import { ReactComponent as MyWalletSvg } from '@/assets/icon/icon_my_wallet.svg';
import { ReactComponent as Other } from '@/assets/icon/icon_other.svg';
import { ReactComponent as PayCopySvg } from '@/assets/icon/icon_pay_copy.svg';
import { ReactComponent as PayCopySuccessSvg } from '@/assets/icon/icon_pay_copy_success.svg';
import { ReactComponent as RoundPESvg } from '@/assets/icon/icon_pe.svg';
import { ReactComponent as Phone } from '@/assets/icon/icon_phone.svg';
import { ReactComponent as Promotion } from '@/assets/icon/icon_promotion.svg';
import { ReactComponent as PullDownSvg } from '@/assets/icon/icon_pullDown.svg';
import { ReactComponent as Question } from '@/assets/icon/icon_question.svg';
import { ReactComponent as Recharge } from '@/assets/icon/icon_recharge.svg';
import { ReactComponent as RechargeRecord } from '@/assets/icon/icon_recharge_record.svg';
import { ReactComponent as Right } from '@/assets/icon/icon_right.svg';
import { ReactComponent as RoundRsSvg } from '@/assets/icon/icon_round_rs.svg';
import Rs from '@/assets/icon/icon_rs.webp';
import { ReactComponent as Share } from '@/assets/icon/icon_share.svg';
import { ReactComponent as Slot } from '@/assets/icon/icon_slot.svg';
import { ReactComponent as TimeSvg } from '@/assets/icon/icon_time.svg';
import { ReactComponent as Upgrade } from '@/assets/icon/icon_upgrade.svg';
import { ReactComponent as WhatsApp } from '@/assets/icon/icon_whatsapp.svg';
import { ReactComponent as WithdrawCPF } from '@/assets/icon/icon_withdraw_CPF.svg';
import { ReactComponent as WithdrawEmail } from '@/assets/icon/icon_withdraw_email.svg';
import { ReactComponent as WithdrawName } from '@/assets/icon/icon_withdraw_name.svg';
import { ReactComponent as WithdrawPhone } from '@/assets/icon/icon_withdraw_phone.svg';
import { ReactComponent as WithdrawRecord } from '@/assets/icon/icon_withdraw_record.svg';
import { ReactComponent as BindSvg } from '@/assets/icon/icon-bind.svg';
import { ReactComponent as PwaAddSvg } from '@/assets/icon/icon-pwa-add.svg';
import { ReactComponent as EmptySvg } from '@/assets/icon/iconempty.svg';
import { ReactComponent as Lock } from '@/assets/icon/lock.svg';
import { ReactComponent as MinusSvg } from '@/assets/icon/minus.svg';
import { ReactComponent as MusicSvg } from '@/assets/icon/music.svg';
import { ReactComponent as NavbarBonus } from '@/assets/icon/navbar_bonus.svg';
import { ReactComponent as NavbarJOGO } from '@/assets/icon/navbar_jogo.svg';
import { ReactComponent as NavbarPromotion } from '@/assets/icon/navbar_promotion.svg';
import { ReactComponent as NavbarRecharge } from '@/assets/icon/navbar_recharge.svg';
import { ReactComponent as NavbarShare } from '@/assets/icon/navbar_share.svg';
import { ReactComponent as PlusSvg } from '@/assets/icon/plus.svg';
import { ReactComponent as RuletaSvg } from '@/assets/icon/RULETA.svg';
import { ReactComponent as SlotsSvg } from '@/assets/icon/SLOTS.svg';
import { ReactComponent as SoundSvg } from '@/assets/icon/sound.svg';
import { ReactComponent as StepArrowSvg } from '@/assets/icon/step_arrow.svg';
import { ReactComponent as GiftCloseSvg } from '@/assets/rechare/gift-close.svg';

import BlurryLoadingImage from '../progressive-img';

interface IconProps {
  style?: CSSProperties;
  className?: string;
  onClick?: () => void;
}
export const IconHot = (props: IconProps) => <Hot {...props} />;
export const IconOther = (props: IconProps) => <Other {...props} />;
export const IconSlot = (props: IconProps) => <Slot {...props} />;

export const IconGame = (props: IconProps) => <Game {...props} />;
export const IconMy = (props: IconProps) => <My {...props} />;
export const IconPromotion = (props: IconProps) => <Promotion {...props} />;
export const IconShare = (props: IconProps) => <Share {...props} />;
export const IconRecharge = (props: IconProps) => <Recharge {...props} />;
export const IconQuestion = (props: IconProps) => <Question {...props} />;
export const IconDownload = (props: IconProps) => <Download {...props} />;
export const IconAccountType = (props: IconProps) => <AccountType {...props} />;
export const IconBottom = (props: IconProps) => <Bottom {...props} />;
export const IconRight = (props: IconProps) => <Right {...props} />;

export const IconLink = (props: IconProps) => <Link {...props} />;
export const IconFacebook = (props: IconProps) => <Facebook {...props} />;
export const IconWhatsapp = (props: IconProps) => <WhatsApp {...props} />;
export const IconPhone = (props: IconProps) => <Phone {...props} />;

export const IconBack = (props: IconProps) => <Back {...props} />;

export const IconRechargeRecord = (props: IconProps) => <RechargeRecord {...props} />;

export const IconArrowRight = (props: IconProps) => <ArrowRight {...props} />;
export const IconArrowLeft = (props: IconProps) => <ArrowLeft {...props} />;
export const IconArrowDown = (props: IconProps) => <ArrowDown {...props} />;
export const IconStepArrow = (props: IconProps) => <StepArrowSvg {...props} />;
export const IconCoin = (props: IconProps) => <BlurryLoadingImage src={Rs} {...props} />;

export const IconManyCoin = (props: IconProps) => <BlurryLoadingImage src={ManyRs} {...props} />;

export const IconWithdrawRecord = (props: IconProps) => <WithdrawRecord {...props} />;
export const IconWithdrawCPF = (props: IconProps) => <WithdrawCPF {...props} />;
export const IconDNI = (props: IconProps) => <DNI {...props} />;
export const IconWithdrawName = (props: IconProps) => <WithdrawName {...props} />;
export const IconWithdrawEmail = (props: IconProps) => <WithdrawEmail {...props} />;
export const IconWithdrawPhone = (props: IconProps) => <WithdrawPhone {...props} />;
export const IconCrown = (props: IconProps) => <Crown {...props} />;
export const IconKefu = (props: IconProps) => <Kefu {...props} />;
export const IconLock = (props: IconProps) => <Lock {...props} />;
export const GiftClose = (props: IconProps) => <GiftCloseSvg {...props} />;
export const IconTime = (props: IconProps) => <TimeSvg {...props} />;

export const IconCorrect = (props: IconProps) => <Correct {...props} />;

export const IconCorrectCircle = (props: IconProps) => <CorrectCircle {...props} />;

export const DefaultUser = (props: IconProps) => <DefaultUserAvatar {...props} />;

export const IconBank = (props: IconProps) => <BankSvg {...props} />;

export const IconCopy = (props: IconProps) => <CopySvg {...props} />;

export const PayCopy = (props: IconProps) => <PayCopySvg {...props} />;

export const PayCopySuccess = (props: IconProps) => <PayCopySuccessSvg {...props} />;

export const CloseOutLine = (props: IconProps) => <CloseOutLineSvg {...props} />;

export const IconBindRole = (props: IconProps) => <BindRoleSvg {...props} />;

export const IconBind = (props: IconProps) => <BindSvg {...props} />;

export const BindPhoneTip = (props: IconProps) => <BindPhoneTipSvg {...props} />;

export const IconPwaAdd = (props: IconProps) => <PwaAddSvg {...props} />;

export const IconLightning = (props: IconProps) => <LightningSvg {...props} />;

export const IconMyGold = (props: IconProps) => <MyGoldSvg {...props} />;

export const IconMyGoldSimple = (props: IconProps) => <MyGoldSimpleSvg {...props} />;

export const IconMyWallet = (props: IconProps) => <MyWalletSvg {...props} />;

export const GoBack = (props: IconProps) => <GoBackSvg {...props} />;

export const RoundRs = (props: IconProps) => <RoundRsSvg {...props} />;
export const RoundPE = (props: IconProps) => <RoundPESvg {...props} />;
export const HomeUser = (props: IconProps) => <HomeUserSvg {...props} />;

export const IconEmpty = (props: IconProps) => <EmptySvg {...props} />;
export const IconMail = (props: IconProps) => <MailSvg {...props} />;
export const IconMusic = (props: IconProps) => <MusicSvg {...props} />;
export const IconSound = (props: IconProps) => <SoundSvg {...props} />;

export const IconReadMail = (props: IconProps) => <MailReadSvg {...props} />;

export const IconDeleteMail = (props: IconProps) => <MailDeleteSvg {...props} />;
export const IconUpgrade = (props: IconProps) => <Upgrade {...props} />;
export const IconHots = (props: IconProps) => <HotSvg {...props} />;
export const IconCasino = (props: IconProps) => <CasinoSvg {...props} />;
export const IconBingo = (props: IconProps) => <BingoSvg {...props} />;
export const IconDeportes = (props: IconProps) => <DeportesSvg {...props} />;
export const IconSlots = (props: IconProps) => <SlotsSvg {...props} />;
export const IconRuleta = (props: IconProps) => <RuletaSvg {...props} />;
export const IconMinus = (props: IconProps) => <MinusSvg {...props} />;
export const IconPlus = (props: IconProps) => <PlusSvg {...props} />;
export const IconPullDown = (props: IconProps) => <PullDownSvg {...props} />;

export const IconNavbarBonus = (props: IconProps) => <NavbarBonus {...props} />;
export const IconNavbarJogo = (props: IconProps) => <NavbarJOGO {...props} />;
export const IconNavbarPromotion = (props: IconProps) => <NavbarPromotion {...props} />;
export const IconNavbarRecharge = (props: IconProps) => <NavbarRecharge {...props} />;
export const IconNavbarShare = (props: IconProps) => <NavbarShare {...props} />;

export { ReactComponent as Camera } from '@/assets/icon/camera.svg';
export { ReactComponent as IconPointer } from '@/assets/icon/pointer.svg';
export { ReactComponent as QuestionFilled } from '@/assets/icon/question_filled.svg';
export { ReactComponent as IconStar } from '@/assets/icon/star.svg';
export { ReactComponent as Usdt } from '@/assets/icon/usdt.svg';
export { ReactComponent as WithdrawBank } from '@/assets/icon/withdraw_bank.svg';
export { ReactComponent as WithdrawUser } from '@/assets/icon/withdraw_user.svg';
